import { Button, Typography, useTheme, Grid } from '@mui/material'
import { FC } from 'react'
import { LabeledText } from '../../../../../../components/CustomTypography'
import { StyledCard } from '../../../../../../components/StyledCard'

interface IPFCardProps {
  amount: string
  refId: string
  technologyId: string
  technologyTitle: string
  organizationName: string
  handlePFSlideOut: (technologyId: string, refId: string) => void
}

export const PFCard: FC<IPFCardProps> = ({ technologyId, refId ,organizationName, amount, technologyTitle, handlePFSlideOut }) => {
  const theme = useTheme()

  return (
    <Grid item xs={3}>
      <StyledCard
        sx={{
          p: 2,
          minHeight: '230px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          mb={2}
          color="secondary"
          fontSize="0.9rem"
          fontWeight={theme.typography.fontWeightBold}
        >
          {organizationName}
        </Typography>

        <LabeledText
          label="Project"
          value={technologyTitle}
          valueProps={{ fontSize: '0.9rem' }}
          rootContainerProps={{
            my: 1,
            gap: 0,
            alignItems: 'flex-start',
            direction: 'column',
          }}
        />

        <LabeledText
          label="Total Grants Paid"
          value={`$${amount}`}
          valueProps={{ fontSize: '0.9rem' }}
          rootContainerProps={{
            my: 1,
            gap: 0,
            alignItems: 'flex-start',
            direction: 'column',
          }}
        />

        <Button
          variant="outlined"
          disableElevation
          color="secondary"
          sx={{
            mt: 2,
            height: '36px',
            color: 'secondary',
            background: 'white',
            borderRadius: '8px',
            fontSize: '0.857rem',
            textTransform: 'none',
            letterSpacing: '0.2px',
            borderColor: theme.palette.grey[300],
          }}
          onClick={() => handlePFSlideOut(technologyId, refId)}
        >
          Foundation info
        </Button>
      </StyledCard>
    </Grid>
  )
}
